<script>

export default {
    data() {
        return {
            email: '',
            password: '',
            password_confirmation: '',
            loading: false,
            error: null,
            errors: {},
            token: this.$route.query.token,
        }
    },
    methods: {
        send() {
            if (this.password !== this.password_confirmation) {
                this.errors = {
                    password_confirmation: [ this.$t('auth.first_password.passwords_mismatch') ]
                }
                return;
            }
            this.loading = true;
            this.error = null;
            this.errors = {};
            axios.post('/set-first-password', {
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                token: this.token,
            }).then((data) => {
                this.$toast.open({
                    message: this.$t('auth.first_password.password_set'),
                    duration: 3000,
                });
                this.loading = false;
                this.$router.push({name: 'login'});
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
                this.error = data.response?.data?.error;
                if (this.error) {
                    this.$toast.error(this.error);
                }
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">
                        <form @submit.prevent="send" class="panel is-link">
                            <p class="panel-heading">
                                {{ $t('auth.first_password.title_label') }}
                            </p>
                            <div class="box no-top-radius">

                                <b-field :label="$t('auth.fields.email.name')"
                                         :type="errors.email ? 'is-danger' : null"
                                         :message="errors.email ? errors.email[0] : null">
                                    <b-input
                                        required
                                        type="email"
                                        :placeholder="$t('auth.fields.email.placeholder')"
                                        v-model="email"
                                        icon="at"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('auth.fields.password.name')"
                                         :type="errors.password ? 'is-danger' : null"
                                         :message="errors.password ? errors.password[0] : null">
                                    <b-input
                                        autocomplete="new-password"
                                        type="password"
                                        placeholder="********"
                                        v-model="password"
                                        icon="lock"
                                    ></b-input>
                                </b-field>

                                <b-field :label="$t('auth.fields.password_confirmation.name')"
                                         :type="errors.password_confirmation ? 'is-danger' : null"
                                         :message="errors.password_confirmation ? errors.password_confirmation[0] : null">
                                    <b-input
                                        autocomplete="new-password"
                                        type="password"
                                        placeholder="********"
                                        v-model="password_confirmation"
                                        icon="lock"
                                    ></b-input>
                                </b-field>

                                <div class="buttons is-centered mt-6">
                                    <button class="button is-success is-fullwidth" type="submit"
                                            v-bind:disabled="loading"
                                            v-bind:class="{'is-loading': loading}">
                                        {{ $t('actions.send') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
